import React, { useEffect, useState, Suspense, useRef } from "react";
import Carousel from "react-spring-3d-carousel";
import { v4 as uuidv4 } from "uuid";
import { useDrag, useGesture } from "react-use-gesture";

import { CarouselSliderStyle, CarouselLegenda } from "./styled";
import CarouselSlideContent from "../CarouselSlideContent/CarouselSlideContent";

// Generic gallery carousel — same behaviour as the Perspectivas/AreaComum
// sliders, but with gallery-agnostic prop names so it can back any of the
// extra galleries (galeria-3, galeria-4).
const CarouselSliderGaleria = ({ setup, setSetup, imagesList }) => {
  const [slides, setSlides] = useState([]);
  const [dragged, _setDragged] = useState(false);
  const draggedRef = useRef(dragged);
  const setDragged = (data) => {
    draggedRef.current = data;
    _setDragged(data);
  };

  const bind = useGesture({
    onDrag: ({
      active,
      movement: [mx],
      direction: [xDir],
      distance,
      cancel,
    }) => {
      if (active && distance > window.innerWidth / 10) {
        let direction = Math.round(xDir);
        setDragged(true);
        cancel();
        if (direction === -1) {
          let newIndex = 0;
          if (setup.currentSlide < setup.slidesLength - 1) {
            newIndex = setup.currentSlide + 1;
          }
          setSetup((values) => ({
            ...values,
            currentSlide: newIndex,
            goToSlide: newIndex,
          }));
        } else {
          let newIndex = setup.slidesLength;
          if (setup.currentSlide > 0) {
            newIndex = setup.currentSlide - 1;
          }
          setSetup((values) => ({
            ...values,
            currentSlide: newIndex,
            goToSlide: newIndex,
          }));
        }
      }
    },
  });

  const slidesTemp = imagesList.map((image, index) => {
    const idTrim = image.title.replace(/\s+/g, "") + index;
    return {
      key: uuidv4(),
      content: (
        <CarouselSlideContent
          Style={CarouselSliderStyle}
          Legenda={CarouselLegenda}
          image={image}
          idTrim={idTrim}
          bindProps={bind()}
          onClick={(e) => {
            if (!draggedRef.current) {
              setSetup((values) => ({
                ...values,
                currentSlide: index,
                goToSlide: index,
              }));
            } else {
              setDragged(false);
            }
          }}
        />
      ),
    };
  });

  useEffect(() => {
    setSlides(slidesTemp);
  }, [imagesList]);

  if (setup) {
    return (
      <Suspense fallback={null}>
        <Carousel
          slides={slides}
          goToSlide={setup.goToSlide}
          offsetRadius={setup.offsetRadius}
          showNavigation={setup.showNavigation}
          animationConfig={setup.config}
        />
      </Suspense>
    );
  } else {
    return <></>;
  }
};

export default CarouselSliderGaleria;
